import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-head-off-executives',
  templateUrl: './head-off-executives.component.html',
  styleUrls: ['./head-off-executives.component.scss']
})
export class HeadOffExecutivesComponent implements OnInit {

  public officesList: any = [];
  constructor() { }

  ngOnInit(): void {
    this.officesList = [
      {
        "sNo": 1,
        "officeName": "Sh. Birender Singh",
        "designation": "Administrator",
        "contact_landLine": "0172-2566408, 2571031, \n FAX-0172-2562275",
        "email_address": "admr.cadapkl@gmail.com"
      },
      {
        "sNo": 2,
        "officeName": "Sh. S.D.Sharma",
        "designation": "Chief Engineer",
        "contact_landLine": "0172-2565984",
        "email_address": "chiefengineercada@gmail.com"
      },
      {
        "sNo": 3,
        "officeName": "Sh. Parshant, HCS",
        "designation": "Officer on Special Duty",
        "contact_landLine": "0172-2567034",
        "email_address": "osdcadapkl@gmail.com"
      },
      {
        "sNo": 4,
        "officeName": "Sh. Dhoop Singh",
        "designation": "Director Micro -Irrigation ",
        "contact_landLine": "0172-2990399",
        "email_address": "dmicada2021@gmail.com"
      },
      {
        "sNo": 5,
        "officeName": "Sh. Rajesh Yadav",
        "designation": "Joint Director (Stat.)",
        "contact_landLine": "0172-2564317",
        "email_address": "jds.cadaharyana@gmail.com"
      },
      {
        "sNo": 6,
        "officeName": "Sh. Sanjeev Jain",
        "designation": "Chief Accounts Officer",
        "contact_landLine": "0172-2567032",
        "email_address": "cada.acctt@gmail.com"
      },
      {
        "sNo": 7,
        "officeName": "Vacant",
        "designation": "Executive Engineer (Works)",
        "contact_landLine": "0172-2573422",
        "email_address": "xenworkscada@gmail.com"
      },
      {
        "sNo": 8,
        "officeName": "Sh. Rajesh Kumar",
        "designation": "Deputy Director ",
        "contact_landLine": "0172-2564317"
      },
      {
        "sNo": 9,
        "officeName": "Sh. Diwan Chand",
        "designation": "Secretary\/Administrator",
        "contact_landLine": "0172-2566408, 2571031",
        "email_address": "psadmrcada@gamil.com"
      },
      {
        "sNo": 10,
        "officeName": "Sh. Hanuman Jha",
        "designation": "Computer Programmer",
        "contact_landLine": 7696096743,
        "email_address": "computerprogrammercada@gmail.com"
      },
    ];
  }

}

